export default __webpack_public_path__ + "static/media/solid-right.8e3f7c01.svg";